<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <!-- <div class="page_title">
            Your profile
            <el-progress class="progress" :percentage="94" :show-text="false" color="#2463FF" />
        </div> -->
        <div class="container">
                <div class="auth-header">
                    <div class="auth-heading">
                        <h1>Your Profile</h1>
                        <p class="auth-subtext">Upload a profile picture</p>
                    </div>
                </div>
        <el-form :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="'userForm'"
            :label-position="'top'" @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
            <div class="avatar_uploader" :class="formsData.userForm.img ? 'with_image' : 'no_image'">
                <el-upload data-testid="directions-118" action="#" ref="upload" list-type="picture-card"
                    class="el-upload-list--single" :auto-upload="false" drag :on-change="cropperMethods.handleChange">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <template #file="{ file }" class="item-thumbnail_wrapper">
                        <span class="el-upload-list__item-actions">
                            <span v-if="formsData.userForm.img" class="el-upload-list__item-delete"
                                @click="cropperMethods.handleRemove(file, formsData.userForm.fileList)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>

                    </template>



                </el-upload>
                <div class="avatar_uploader_cropper" v-if="formsData.userForm.img"
                    :class="userRole == 'locum' ? 'circle' : 'rectangle'">
                    <div class="avatar_uploader_preview">
                        <preview :width="140" :height="140" :image="formsData.userForm.result.image"
                            :coordinates="formsData.userForm.result.coordinates" />
                        <preview :width="96" :height="96" :image="formsData.userForm.result.image"
                            :coordinates="formsData.userForm.result.coordinates" />
                        <preview :width="48" :height="48" :image="formsData.userForm.result.image"
                            :coordinates="formsData.userForm.result.coordinates" />
                    </div>
                    <cropper class="cropper" ref="cropper" :src="formsData.userForm.img"
                        :stencil-props="{ aspectRatio: 1 }" @change="cropperMethods.onChange" :debounce="false"
                        :stencil-component="userRole == 'locum' ? CircleStencil : RectangleStencil" />
                </div>
            </div>

            <el-form-item class="button_submit mb0">
                <el-button class="submit btn-primary" type="blue" data-testid="directions-119"
                    @click="goNext('userForm')" :disabled="formsData.userForm.img ? false : true">
                    Continue
                </el-button>
            </el-form-item>
        </el-form>
        </div>
    </div>
</template>

<script>
import {
    Cropper,
    Preview,
    CircleStencil,
    RectangleStencil
} from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

import {
    ElMessage
} from '@/components/Vendor/Element';

import {
    ref,
    reactive,
    onMounted,
    inject
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'

import IMaskDirective from '@/directives/vue-imask/directive';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        Cropper,
        Preview,
    },
    Components: {
        CircleStencil,
        RectangleStencil,
    },
    directives: {
        imask: IMaskDirective
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');

        const user = $store.getters.GET_USER_DATA;
        const userRole = user.role;

        const routeName = $route.name;

        const userForm = ref(null);
        const cropper = ref(null);
        const backPage = $store.getters.getLastPage;
        console.log("🚀 ~ setup ~ backPage:", backPage)
        let formNames = ['userForm'];

        const formsDataArray = [{
            fileList: [],
            img: null,
            type: null,
            result: {
                coordinates: null,
                image: null
            },
        }];

        // const beforeAvatarUpload = (file) => {
        //     console.log("check jpg", file);
        //     const isJPG = file.type === 'image/jpeg';
        //     const isLt2M = file.size / 1024 / 1024 < 5;

        //     if (!isJPG) {
        //     ElMessage({
        //         type: 'error',
        //         message: 'Avatar picture must be in JPG format!'
        //     });
        //     }
        //     if (!isLt2M) {
        //     ElMessage({
        //         type: 'error',
        //         message: 'Avatar picture size cannot exceed 5MB!'
        //     });
        //     }

        //     return isJPG && isLt2M;
        // };

        const cropperMethods = {
            handleRemove(file) {
                formsData.userForm.fileList.splice(formsData.userForm.fileList.indexOf(file), 1);
                formsData.userForm.img = '';
            },
            handleChange(file, fileList) {
                const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/svg+xml';

                const isLt2M = file.size / 1024 / 1024 < 5;

                if (!isJPG) {
                    ElMessage({
                        type: 'error',
                        message: 'Avatar picture must be in JPG, PNG and SVG format!'
                    });
                    return;
                }
                if (!isLt2M) {
                    ElMessage({
                        type: 'error',
                        message: 'Avatar picture size cannot exceed 5MB!'
                    });
                    return;
                }
                if (fileList.length > 1) {
                    fileList.shift();
                }
                formsData.userForm.fileList = fileList;
                formsData.userForm.img = file.url;
                formsData.userForm.type = file.raw.type

            },
            onChange({
                coordinates,
                image
            }) {
                formsData.userForm.result = {
                    coordinates,
                    image
                };
            }
        }

        const goBack = () => {

            if (backPage === "/job-seeker/profile") {
                $router.push({
                    name: "job_seeker_profile"
                })
            } else {
                $router.push({
                    name: $store.getters.getAuthPageBack
                })
            }


        };

        const goNext = () => {
            const {
                canvas
            } = cropper.value.getResult();

            if (canvas) {
                const form = new FormData();
                canvas.toBlob(blob => {
                    form.append('image', blob);
                    (async () => {
                        try {
                            await $store.dispatch('SAVE_JOB_SEEKER_IMAGE', form);
                            if (backPage === "/job-seeker/profile") {
                                $router.push({
                                    name: "job_seeker_profile"
                                })
                            } else {
                                $router.push({
                                    name: 'jobseeker_auth_preview',
                                });
                            }

                        } catch (error) {
                            console.log('error submit!!');
                        }
                    })();
                }, formsData.userForm.type);
            }
        }

        // const skip = () => {
        //     if (backPage === "/job-seeker/profile") {
        //         $router.push({
        //             name: "job_seeker_profile"
        //         })
        //     } else {
        //         $router.push({
        //             name: 'jobseeker_auth_enhance',
        //         });
        //     }

        // }

        onMounted(() => {
            setPageClassGlobal('global_auth_page global_user_photo_page');
        });

        let createFormsData = (formNames) => {
            let formsData = {};
            formNames.forEach((element, i) => {
                formsData[element] = formsDataArray[i];
            });
            return formsData;
        }

        let formsData = createFormsData(formNames, formsDataArray);

        formsData = reactive(formsData);

        return {
            userForm,
            formsData,
            goBack,
            goNext,
            // skip,
            userRole,
            routeName,
            CircleStencil,
            RectangleStencil,
            cropper,
            cropperMethods
        }
    },
}
</script>